import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { UserRole } from '../data/UpuServiceDataCertificationRequestModel';
import { UserApi } from '../features/user/user-api';
import { ROUTE_DATA } from './route-data';

const ALLOWED_ROLES: ReadonlySet<UserRole> = new Set([
  UserRole.Administrator,
  UserRole.Superuser,
]);

export const systemLogsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userApi = inject(UserApi);

  return (
    ALLOWED_ROLES.has(userApi.userRole()) ||
    router.createUrlTree([ROUTE_DATA['not-found'].path])
  );
};
